
@if (ready) {
    <div class="planning" [class.keyboard-active]="keyboardActive || keyboardActiveTimeout" [class.select-dates]="selectDatesActive" [class.selected-dates]="selectedDays | objLen">
        <!-- {{temp | json}} -->
        <div class="head-wrap">
            <div class="select-date">
                <button class="prev" [class.hidden]="!allowPrevMonth" (click)="prev()">
                    <i></i>
                </button>
                <div>{{currentMonth | formatTs: 'MMMM YYYY'}}</div>
                <button class="next" (click)="next()">
                    <i></i>
                </button>
            </div>
            @if (!isControlcenter) {
                <button class="info-button" (click)="expandLegend()"><i></i></button>
            }
        </div>
        <ngx-pull-to-refresh
            spinnerColor="#E42834"
            spinnerSize="24"
            distanceForRefresh="40"
            [isEnable]="!(jobDetailExpanded || disablePullToRefresh || submitting)"
            (refresh)="reloadPlanning(null, $event);"
            style="display:block;height:100%;">
            <div class="calendar-wrap">
                <div class="weekDays">
                    @for (day of weekDays; track day; let $i = $index) {
                        <div class="weekDay" [class.weekend]="$i == 5 || $i == 6">{{day}}</div>
                    }
                </div>
                <div class="days" [class.no-pointer]="loadingPlanning" (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
                    <!-- offset month -->
                    @for (day of currentMonthDayOffset; track day) {
                        <div class="day day--offset"></div>
                    }
                    <!-- days in this month -->
                    @for (day of currentMonthDays; track day) {
                        <div class="day day--calendar"
                            (click)="clickDay(day.date)"
                            [class.day--available]="day.available === true"
                            [class.day--unavailable]="day.available === false"
                            [class.day--mixed]="day.unavailable?.length"
                            [class.day--selected]="selectedDay.date === day.date || selectedDays[day.date]"
                            [class.day--jobs-open]="day.actionsOpen?.length"
                            [class.day--jobs-applied]="day.actionsApplied?.length"
                            [class.day--jobs-to-accept]="day.actionsToAccept?.length"
                            [class.day--jobs-accepted]="day.actionsAccepted?.length"
                            [class.day--is-past]="day.isPast"
                            [attr.data-date]="day.date | formatTs: 'YYYY-MM-DD'"
                            [attr.data-is-past]="day.isPast">
                            <div class="day--inner">
                                @for (range of day?.unavailable; track range) {
                                    @if (range.percentageOfDay) {
                                        <div class="range" style="--pLength:{{range.percentageOfDay}};--rotate:{{range.rotateAmount}}deg"></div>
                                    }
                                }
                                <span class="date">{{day.date | formatTs: 'D'}}</span>
                                @if (day.actionsToAccept?.length) {
                                    <span class="notif--jobs-to-accept">{{day.actionsToAccept.length}}</span>
                                }
                                @if (day.actionsOpen?.length && !day.actionsToAccept?.length) {
                                    <span class="notif--jobs-open">{{(day.actionsOpen?.length || 0)}}</span>
                                }
                                <!-- <span *ngIf="(day.actionsOpen?.length || day.actionsApplied?.length) && !day.actionsToAccept?.length" class="notif--jobs-open">{{(day.actionsOpen?.length || 0) + (day.actionsApplied?.length || 0)}}</span> -->
                            </div>
                        </div>
                    }
                </div>
            </div>
        </ngx-pull-to-refresh>
        <div class="slideout-wrap" (touchstart)="touchSlideout($event, 'start')" (touchend)="touchSlideout($event, 'end')">
            <div class="slideout" [class.slideout--expanded]="slideoutExpanded">
                <!-- default view -->
                @if (!selectDatesActive) {
                    <div class="slideout-head">
                        <div>@if (!slideoutExpanded && !(selectedDays | objLen) && slideoutTab === 'availability' && !selectedDay.isPast) {
                            <button class="select-dates" (click)="selectDates()">+ <span>{{'planning_select_days' | translate}}</span></button>
                        }</div>
                        @if (!(selectedDays | objLen)) {
                            <div><div class="title">{{selectedDay.date | formatTs: 'D MMMM YYYY'}}</div></div>
                        }
                        @if ((selectedDays | objLen)) {
                            <div><div class="title">{{selectedDays | objLen}} {{'planning_days_selected' | translate}} <i (click)="cancelSelectDates()"></i></div></div>
                        }
                        <div><button class="slideout-toggle"><i (click)="slideoutExpanded = !slideoutExpanded"></i></button></div>
                    </div>
                    <div class="slideout-switch">
                        @if (!isMerch) {
                            <div class="option-wrap first"><div class="option" (click)="changetab('availability')" [class.active]="slideoutTab === 'availability'">{{'planning_tab_availability' | translate}}</div></div>
                        }
                        <div class="option-wrap"><div class="option" [class.saving]="selectDatesActive || (selectedDays | objLen)" (click)="changetab('jobs')" [class.active]="slideoutTab === 'jobs'"><span class="position-relative">{{'planning_tab_jobs_to_accept' | translate}} @if (selectedDay.actionsToAccept?.length) {
                            <span class="notif--jobs-to-accept">{{selectedDay.actionsToAccept.length}}</span>
                        }</span></div></div>
                        @if (!isMerch) {
                            <div class="option-wrap last"><div class="option" [class.saving]="selectDatesActive || (selectedDays | objLen)" (click)="changetab('open')" [class.active]="slideoutTab === 'open'"><span class="position-relative">{{'planning_tab_jobs_open' | translate}} @if (selectedDay.actionsOpen?.length) {
                                <span class="notif--jobs-open">{{(selectedDay.actionsOpen?.length || 0)}}</span>
                            }</span></div></div>
                        }
                    </div>
                    <!-- AVAILABILITY -->
                    @if (slideoutTab === 'availability') {
                        <div class="slideout-content">
                            <!-- unpopulated | edit -->
                            <ng-container>
                                @if ((selectedDay.available === undefined && !selectedDay?.unavailable?.length && !(selectedDays | objLen)) || ((selectedDays | objLen) && !selectedDaysStatus()) || (editSelectedDayActive || (selectedDays | objLen))) {
                                    <!-- set -->
                                    @if (!unavailabilityFormActive && ((selectedDays | objLen) || !selectedDay.isPast)) {
                                        <div class="slideout-panel slideout-panel--availability--set">
                                            @if (!((selectedDays | objLen))) {
                                                <div class="title">{{'planning_tab_availability_title' | translate}}</div>
                                            }
                                            @if (((selectedDays | objLen))) {
                                                <div class="title">{{'planning_tab_availability_title_multiple_days' | translate}}</div>
                                            }
                                            <div class="app-button app-button--pos" (click)="setAvailable()" [class.no-pointer]="submitting" [class.saving-this]="submitting === 'availability'"><button>{{'planning_tab_availability_button_available' | translate}}</button></div>
                                            <div class="app-button app-button--mixed" [class.no-pointer]="submitting" [class.saving-this]="submitting === ''"><button (click)="setUnavailabilityFormActive()">{{'planning_tab_availablilty_button_mixed' | translate}}</button></div>
                                            <div class="app-button app-button--neg" (click)="setUnavailable()" [class.no-pointer]="submitting" [class.saving-this]="submitting === 'unavailability'"><button>{{'planning_tab_availability_button_not_available' | translate}}</button></div>
                                            <!-- <div class="info" *ngIf="(selectedDays | objLen)">{{'planning_tab_availability_warning_multiple_days' | translate}}</div> --> <!-- @feedback -->
                                            <!-- warning multiple days -->
                                            @if ((selectedDays | objLen)) {
                                                <div class="warning">{{'planning_tab_availability_warning_multiple_days' | translate}}</div>
                                            }
                                            @if (editSelectedDayActive && !(selectedDays | objLen)) {
                                                <button class="cancel-button" (click)="editSelectedDayActive = false; slideoutWrappersToTop();"><i></i>{{'misc_cancel' | translate}}</button>
                                            }
                                            @if ((selectedDays | objLen)) {
                                                <button class="cancel-button" (click)="cancelSelectDates()"><i></i>{{'misc_cancel' | translate}}</button>
                                            }
                                        </div>
                                    }
                                    <!-- emptystate past -->
                                    <!-- <ng-container *ngIf="!unavailabilityFormActive && (!(selectedDays | objLen) && selectedDay.isPast)">
                                    <div class="empty-state empty-state--no-data">{{'planning_past_availability_emptystate' | translate}}</div>
                                </ng-container> -->
                                <!-- form -->
                                @if (unavailabilityFormActive) {
                                    <div class="slideout-panel slideout-panel--unavailability--form">
                                        <button class="back-button" (click)="unavailabilityFormActive = false"><i></i></button>
                                        <div class="title">{{'planning_tab_availability_form_title_1' | translate}} <span>{{'planning_tab_availability_form_title_2' | translate}}</span> {{'planning_tab_availability_form_title_3' | translate}}</div>
                                        <div class="picker-wrap">
                                            <div class="left" [class.saving]="submitting">
                                                @for (FORM of unavailabilityFORM; track FORM) {
                                                    <div class="unavailability">
                                                        <div>
                                                            <span>{{'planning_tab_availability_form_from' | translate}}</span>
                                                            <input [class.invalid]="FORM.invalid" type="text" pattern="[0-9]*" inputmode="numeric" (focus)="onFocusUnavailability()" (blur)="onBlurUnavailability()" (ngModelChange)="onChangeUnavailability()" [mask]="'Hh:m0'" [clearIfNotMatch]="true" [leadZeroDateTime]="true" placeholder="00:00" [(ngModel)]="FORM.localFrom">
                                                            <span>{{'planning_tab_availability_form_until' | translate}}</span>
                                                            <input [class.invalid]="FORM.invalid" type="text" pattern="[0-9]*" inputmode="numeric" (focus)="onFocusUnavailability()" (blur)="onBlurUnavailability()" (ngModelChange)="onChangeUnavailability()" [mask]="'Hh:m0'" [clearIfNotMatch]="true" [leadZeroDateTime]="true" placeholder="00:00" [(ngModel)]="FORM.localUntil">
                                                        </div>
                                                        @if (FORM.invalid) {
                                                            <div class="warning-msg">{{'planning_tab_availability_form_warning_msg' | translate}}</div>
                                                        }
                                                    </div>
                                                }
                                                @if (unavailabilityFORM.length < 3) {
                                                    <button class="link" (click)="addUnavailability()">+ {{'planning_tab_availability_form_add_another_unavailability' | translate}}</button>
                                                }
                                            </div>
                                            <div class="right">
                                                <div class="day-circle">
                                                    <span class="top">12:00</span>
                                                    <span class="right">18:00</span>
                                                    <span class="bottom">00:00</span>
                                                    <span class="left">06:00</span>
                                                    <i class="icon-sun"></i>
                                                    <i class="icon-moon"></i>
                                                    <i class="sep"></i>
                                                    @for (range of unavailabilityFORM; track range) {
                                                        @if (range.from && range.until && range.percentageOfDay) {
                                                            <div class="range" style="--pLength:{{range.percentageOfDay}};--rotate:{{range.rotateAmount}}deg"></div>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <button class="submit-button saving--pre" [class.saving]="!allowSubmitUnavailabilities() || submitting" (click)="submitUnavailabilities()">{{'planning_tab_availability_form_save' | translate}}</button>
                                    </div>
                                }
                            }
                        </ng-container>
                        <!-- populated -->
                        @if (((selectedDay.available !== undefined || selectedDay?.unavailable?.length) && !(selectedDays | objLen) && !editSelectedDayActive) || ((selectedDays | objLen) && selectedDaysStatus() && !editSelectedDayActive) && !(selectedDays | objLen)) {
                            <div class="slideout-panel slideout-panel--availability--populated">
                                @if (!(selectedDays | objLen)) {
                                    <div class="title">{{'planning_tab_populated_title' | translate}}</div>
                                }
                                @if ((selectedDays | objLen) && selectedDaysStatus() !== 'mixed') {
                                    <div class="title">{{'planning_tab_populated_title_multiple_days' | translate}}</div>
                                }
                                @if ((selectedDays | objLen) && selectedDaysStatus() === 'mixed') {
                                    <div class="title">{{'planning_tab_populated_title_multiple_days_mixed_availability' | translate}}</div>
                                }
                                @if ((!(selectedDays | objLen) && selectedDay.available === true) || ((selectedDays | objLen) && selectedDaysStatus() === 'pos')) {
                                    <div class="app-button app-button--pos"><button>{{'planning_tab_populated_status_available' | translate}}</button></div>
                                }
                                @if (selectedDay.unavailable?.length && !(selectedDays | objLen)) {
                                    <div class="app-button app-button--mixed"><button>{{'planning_tab_populated_status_mixed' | translate}}</button></div>
                                }
                                @if ((!(selectedDays | objLen) && selectedDay.available === false) || ((selectedDays | objLen) && selectedDaysStatus() === 'neg')) {
                                    <div class="app-button app-button--neg"><button>{{'planning_tab_populated_status_unavailable' | translate}}</button></div>
                                }
                                @if (selectedDay?.unavailable?.length && !(selectedDays | objLen)) {
                                    <div class="not-available-times">
                                        <span>{{'planning_tab_populated_not_available_title' | translate}}</span>
                                        @for (time of selectedDay.unavailable; track time) {
                                            <span>{{'planning_tab_populated_not_available_from' | translate}} {{time.from}} {{'planning_tab_populated_not_available_until' | translate}} {{time.until}}</span>
                                        }
                                    </div>
                                }
                                @if (!(selectedDays | objLen) && !selectedDay.isPast) {
                                    <button class="edit-button" (click)="editSelectedDayActive = true; slideoutWrappersToTop();"><i></i>{{'planning_tab_populated_button_edit' | translate}}</button>
                                }
                                <!-- <button *ngIf="(selectedDays | objLen)" class="edit-button" (click)="editSelectedDayActive = true"><i></i>{{'planning_tab_populated_button_edit_multiple_days' | translate}}</button> -->
                            </div>
                        }
                        <!-- emptystate past -->
                        @if (!unavailabilityFormActive && (!(selectedDays | objLen) && selectedDay.isPast)) {
                            <div class="empty-state empty-state--no-data" [class.pt-1]="!((selectedDay.available === undefined && !selectedDay?.unavailable?.length && !(selectedDays | objLen)) || ((selectedDays | objLen) && !selectedDaysStatus()) || editSelectedDayActive)">{{'planning_past_availability_emptystate' | translate}}</div>
                        }
                    </div>
                }
            }
            <!-- SELECT DATES -->
            @if (selectDatesActive) {
                <div class="slideout-head">
                    <div><button class="cancel-select-dates" (click)="cancelSelectDates()"><span>{{'misc_cancel' | translate}}</span></button></div>
                    <div><div class="title">{{'planning_selectdates_title' | translate}} ({{selectedDays | objLen}})</div></div>
                    <div>@if (false) {
                        <button class="confirm-select-dates saving--pre" (click)="confirmSelectDates()" [class.saving]="!((selectedDays | objLen) >= 2)">{{'misc_confirm' | translate}}</button>
                    }<!--@feedback--></div>
                </div>
                <div class="slideout-content">
                    @if (!unavailabilityFormActive) {
                        <div class="slideout-panel slideout-panel--select-dates">
                            @for (day of selectedDays | keyvalue; track day) {
                                <div class="selected-day">{{day.key | formatTs:'DD MMMM YYYY'}}</div>
                            }
                            @if (!(selectedDays | objLen)) {
                                <div class="selected-day empty">{{'planning_selectdates_emptystate' | translate}}</div>
                            }
                            <!-- warning multiple days -->
                            <div class="warning">{{'planning_tab_availability_warning_multiple_days' | translate}}</div>
                            <button class="confirm-select-dates saving--pre" (click)="confirmSelectDates()" [class.saving]="!((selectedDays | objLen) >= 2)">{{'misc_confirm' | translate}}</button>
                        </div>
                    }
                </div>
            }
            <!-- JOBS TO ACCEPT | JOBS ACCEPTED -->
            @if (slideoutTab === 'jobs') {
                <div class="slideout-content">
                    <div class="slideout-jobs">
                        <!-- actionsToAccept -->
                        @for (job of selectedDay.actionsToAccept; track job) {
                            <div class="slideout-panel slideout-panel--job">
                                <app-job [isControlcenter]="isControlcenter" [job]="job" [submitting]="submitting" (info)="expandJobInfo($event)" [toAccept]="true" (accept)="acceptJob($event)" (decline)="refuseJob($event)"></app-job>
                            </div>
                        }
                        <!-- actionsAccepted -->
                        @for (job of selectedDay.actionsAccepted; track job) {
                            <div class="slideout-panel slideout-panel--job">
                                <app-job [isControlcenter]="isControlcenter" [job]="job" [submitting]="submitting" (info)="expandJobInfo($event)"></app-job>
                            </div>
                        }
                        <!-- emptystate -->
                        @if (!selectedDay.actionsAccepted?.length && !selectedDay.actionsToAccept?.length) {
                            <div class="empty-state">{{'planning_jobs_emptystate' | translate}}</div>
                        }
                    </div>
                </div>
            }
            <!-- JOBS OPEN -->
            @if (slideoutTab === 'open') {
                <div class="slideout-content">
                    <div class="slideout-jobs">
                        <!-- actionsApplied -->
                        @for (job of selectedDay.actionsApplied; track job) {
                            <div class="slideout-panel slideout-panel--job">
                                <app-job [isControlcenter]="isControlcenter" [job]="job" [submitting]="submitting" (info)="expandJobInfo($event)" [isOpen]="true" (withdraw)="withdrawJob($event)"></app-job>
                            </div>
                        }
                        <!-- actionsOpen -->
                        @for (job of selectedDay.actionsOpen; track job) {
                            <div class="slideout-panel slideout-panel--job">
                                <app-job [isControlcenter]="isControlcenter" [job]="job" [submitting]="submitting" (info)="expandJobInfo($event)" [isOpen]="true" (apply)="applyJob($event)"></app-job>
                            </div>
                        }
                        <!-- emptystate -->
                        @if (!selectedDay.actionsApplied?.length && !selectedDay.actionsOpen?.length) {
                            <div class="empty-state">{{'planning_openjobs_emptystate' | translate}}</div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="slideout-backdrop" [class.active]="slideoutExpanded" (click)="slideoutExpanded = false"></div>
    <div class="gray-backdrop" [class.active]="jobDetailExpanded || legendExpanded"></div>
    <div class="job-detail" [class.active]="jobDetailExpanded">
        <button class="job-detail-back" (click)="closeJobInfo()"><i></i> {{'misc_back' | translate}}</button>
        @if (jobDetail) {
            <div class="slideout-panel">
                <app-job [isControlcenter]="isControlcenter" [job]="jobDetail" [expanded]="jobDetailExpanded" [isInfo]="true" (info)="expandJobInfo($event)"></app-job>
            </div>
        }
    </div>
    <div class="legend" [class.active]="legendExpanded">
        <button class="legend-back" (click)="closeLegend()"><i></i> {{'misc_back' | translate}}</button>
        <div class="title"><i></i> {{'planning_legend_title' | translate}}</div>
        <div class="slideout-panel">
            <!-- <img src="/collabor8-planning/assets/img/legend.svg" alt="legend"> -->
            <img src="/collabor8-planning/assets/img/legend-{{user.LANGUAGE || 'en'}}.svg" alt="legend">
        </div>
    </div>
</div>
}

<!-- <pull-to-refresh [autoDismiss]="false" [disabled]="jobDetailExpanded || disablePullToRefresh || submitting"></pull-to-refresh> -->